module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_3.e59777e2.png";